<div
    [inlineSVG]="iconPath"
    [ngClass]="classes"
    [ngStyle]="{}"
    [style.stroke]="isStrokeHighlightMode ? highlightColor : 'transparent'"
    [style.fill]="isFillHighlightMode ? highlightColor : 'transparent'"
    [removeSVGAttributes]="removeSVGAttributes"
    [setSVGAttributes]="{ class: 'svg-centered' }"
    [cacheSVG]="true"
    title="{{ title }}"
></div>
